import styled, { keyframes } from "styled-components";
import mainBg from "./../../resources/images/main/main_bg.png";
import mainBgNew from "./../../resources/images/main/main_new_bg.jpg";
import finishBg from "./../../resources/images/main/finish_bg.png";
import {
  blackColor,
  greyTextColor,
  questionDarkTextColor,
  whiteColor,
} from "../../constants/colors";
import { SE_CLIENT_HEIGHT } from "../../constants/data";

const MainBlock = styled.div`
  //min-height: 100vh;
  flex-grow: 1;
  width: 100%;
  background-image: ${(props) =>
    props.isFinish ? `url(${finishBg})` : `url(${mainBgNew})`};
  background-size: cover;
  padding-top: 76px;
  padding-bottom: 25px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: flex;
  opacity: 0;
  transition: 0.2s;
  &.visible {
    opacity: 1;
  }
  > img {
    position: absolute;
    top: 20px;
    width: 100%;
    display: block;
    margin: 0 auto;
  }
  @media (max-width: 767px) {
    // background: ${blackColor};
    padding-bottom: 30px;
    padding-top: 50px;
    > img {
      display: none;
    }
  }
  @media (max-height: ${SE_CLIENT_HEIGHT}px) {
    padding-bottom: 30px;
    padding-top: 30px;
  }
`;

MainBlock.Mobile = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: url(${mainBgNew});
    background-size: cover;
    //&:after {
    //  content: "";
    //  position: absolute;
    //  top: 0;
    //  left: 0;
    //  width: 100%;
    //  height: 130%;
    //  background: rgba(5, 2, 55, 0.78);
    //  backdrop-filter: blur(21px);
    //}
    //img {
    //  width: 100%;
    //}
  }
`;

MainBlock.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

MainBlock.Top = styled.div`
  .premium {
    color: white;
    text-transform: uppercase;
    background: #f37f3d;
    border-radius: 6px;
    padding: 2px 5px;
    font-size: 14px;
  }
  .finish {
    margin-top: -70px;
    @media (max-height: ${SE_CLIENT_HEIGHT}px) {
      margin-top: -155px;
    }
  }
`;
MainBlock.Top.Logo = styled.div`
  padding-top: 50px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 10px;
  img {
    width: 36px;
    height: 36px;
  }
  @media (max-height: ${SE_CLIENT_HEIGHT}px) {
    padding-top: 0;
  }
`;

MainBlock.Center = styled.div`
  display: flex;
  flex-direction: column;
`;

MainBlock.Questions = styled.div`
  display: flex;
  flex-direction: column;
`;

MainBlock.Bottom = styled.div``;

MainBlock.Bottom.Title = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  h2 {
    max-width: 492px;
    text-align: center;
  }
  @media (max-width: 767px) {
    margin-bottom: 20px;
  }
`;

MainBlock.Bottom.Text = styled.div`
  margin-bottom: 12px;
  p {
    color: ${greyTextColor};
  }
`;

const translate = keyframes`
  0% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(-5px);
  }
`;

MainBlock.Bottom.Arr = styled.div`
  margin-bottom: 20px;
  img {
    animation: ${translate} 2s ease-in-out infinite;
  }
`;

MainBlock.Bottom.Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 34px;
  @media (max-width: 767px) {
    justify-content: space-between;
    margin-bottom: 40px;
  }
`;
MainBlock.Bottom.Button = styled.div`
  width: 220px;
  height: 54px;
  margin-left: 7px;
  margin-right: 7px;
  @media (max-width: 767px) {
    min-width: 160px;
    margin-left: 0;
  }
`;
MainBlock.Bottom.Privacy = styled.div`
  font-size: 14px;
  line-height: 20px;
  max-width: 345px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  span {
    color: ${greyTextColor};
  }
  a {
    color: ${whiteColor};
    text-decoration: underline;
    margin-left: 30px;
    margin-right: 30px;
  }
`;

MainBlock.Bottom.Reg = styled.div`
  display: flex;
  justify-content: center;
`;

export { MainBlock };
